import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, NAV, ZONES, TERMITE_LINKS } from "../../data/site";
import { citiesOfZone } from "../../data/cities";

const Col = ({ title, children }) => (
  <div>
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-fern mb-5">{title}</p>
    <ul className="space-y-3 text-[15px] text-cream/85">{children}</ul>
  </div>
);
const FLink = ({ to, children, id }) => <li><Link to={to} data-testid={id} className="hover:text-lime transition-colors">{children}</Link></li>;

export const Footer = () => (
  <footer className="relative bg-forest text-cream grain overflow-hidden pb-24 lg:pb-0" data-testid="site-footer">
    <div className="relative z-[2] max-w-[1400px] mx-auto px-5 lg:px-10 pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo light />
          <p className="mt-6 max-w-sm text-cream/80 leading-relaxed">Traitement anti-moustique professionnel à Bordeaux et dans toute la Gironde : gîtes larvaires, nébulisation, atomiseur et biocides professionnels. Une activité de {COMPANY.legalName}.</p>
          <div className="mt-8 space-y-3 text-[15px]">
            <a href={COMPANY.phoneHref} className="flex items-center gap-3 hover:text-lime" data-testid="footer-phone"><Phone className="w-4 h-4 text-lime" />{COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-lime break-all" data-testid="footer-email"><Mail className="w-4 h-4 text-lime shrink-0" />{COMPANY.email}</a>
            <p className="flex items-start gap-3 text-cream/85"><MapPin className="w-4 h-4 text-lime mt-1 shrink-0" />{COMPANY.street}, {COMPANY.postalCode} {COMPANY.city}</p>
            <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-lime" data-testid="footer-facebook"><Facebook className="w-4 h-4 text-lime" />Suivez-nous sur Facebook</a>
          </div>
        </div>
        <Col title="Le site">
          <FLink to="/" id="footer-home">Accueil</FLink>
          {NAV.map(n => <FLink key={n.path} to={n.path} id={`footer-${n.path.slice(1)}`}>{n.label}</FLink>)}
          <FLink to="/contact" id="footer-contact">Contact & devis</FLink>
        </Col>
        <Col title="Secteurs">
          {ZONES.map(z => <FLink key={z.slug} to={z.path} id={`footer-zone-${z.slug}`}>Anti-moustique {z.name}</FLink>)}
        </Col>
        <Col title="Nos sites termites">
          {TERMITE_LINKS.slice(0, 4).map(l => <li key={l.href}><a href={l.href} target="_blank" rel="noopener" className="hover:text-lime">{l.label}</a></li>)}
          <li className="pt-4 text-xs font-bold uppercase tracking-[0.2em] text-fern">Informations</li>
          <FLink to="/mentions-legales" id="footer-mentions">Mentions légales</FLink>
          <FLink to="/politique-de-confidentialite" id="footer-privacy">Confidentialité & cookies</FLink>
        </Col>
      </div>
      <div className="mt-16 border-t border-cream/10 pt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-5" data-testid="footer-cities">
        {ZONES.map(z => (
          <div key={z.slug}>
            <Link to={z.path} className="text-xs font-bold uppercase tracking-[0.2em] text-fern hover:text-lime">Moustique {z.name}</Link>
            <ul className="mt-4 space-y-2 text-[13px] text-cream/75">
              {citiesOfZone(z.slug).map(c => <li key={c.slug}><Link to={c.path} className="hover:text-lime">Traitement moustique {c.name}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <p aria-hidden="true" className="mt-20 font-display font-extrabold text-[17vw] lg:text-[13rem] leading-[0.8] tracking-[-0.06em] text-cream/[0.06] select-none">moustique.</p>
      <div className="mt-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-cream/60 border-t border-cream/10 pt-6">
        <p>© {new Date().getFullYear()} {COMPANY.legalName} — SIREN {COMPANY.siren} — Traitement anti-moustique Bordeaux & Gironde</p>
        <Link to="/politique-de-confidentialite" className="hover:text-cream">Confidentialité & cookies</Link>
      </div>
    </div>
  </footer>
);
